




































import Vue from "vue";
import { mapGetters } from "vuex";
import { namespaceAuth } from "../../store/auth";

export default Vue.extend({
  name: "HeaderMainBottomMenu",
  computed: {
    ...mapGetters(namespaceAuth, { isLoggedIn: "isLoggedIn", isAdmin: "isAdmin" })
  }
});
